import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::pdf
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:39
* @route '/invoices/pdf/{reference}'
*/
export const pdf = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pdf.url(args, options),
    method: 'get',
})

pdf.definition = {
    methods: ["get","head"],
    url: '/invoices/pdf/{reference}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::pdf
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:39
* @route '/invoices/pdf/{reference}'
*/
pdf.url = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { reference: args }
    }

    if (Array.isArray(args)) {
        args = {
            reference: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        reference: args.reference,
    }

    return pdf.definition.url
            .replace('{reference}', parsedArgs.reference.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::pdf
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:39
* @route '/invoices/pdf/{reference}'
*/
pdf.get = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pdf.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::pdf
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:39
* @route '/invoices/pdf/{reference}'
*/
pdf.head = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: pdf.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::pdf
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:39
* @route '/invoices/pdf/{reference}'
*/
const pdfForm = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pdf.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::pdf
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:39
* @route '/invoices/pdf/{reference}'
*/
pdfForm.get = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pdf.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::pdf
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:39
* @route '/invoices/pdf/{reference}'
*/
pdfForm.head = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pdf.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

pdf.form = pdfForm

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::emailPreview
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:66
* @route '/invoices/email-preview/{reference}'
*/
export const emailPreview = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: emailPreview.url(args, options),
    method: 'get',
})

emailPreview.definition = {
    methods: ["get","head"],
    url: '/invoices/email-preview/{reference}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::emailPreview
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:66
* @route '/invoices/email-preview/{reference}'
*/
emailPreview.url = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { reference: args }
    }

    if (Array.isArray(args)) {
        args = {
            reference: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        reference: args.reference,
    }

    return emailPreview.definition.url
            .replace('{reference}', parsedArgs.reference.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::emailPreview
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:66
* @route '/invoices/email-preview/{reference}'
*/
emailPreview.get = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: emailPreview.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::emailPreview
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:66
* @route '/invoices/email-preview/{reference}'
*/
emailPreview.head = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: emailPreview.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::emailPreview
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:66
* @route '/invoices/email-preview/{reference}'
*/
const emailPreviewForm = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: emailPreview.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::emailPreview
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:66
* @route '/invoices/email-preview/{reference}'
*/
emailPreviewForm.get = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: emailPreview.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::emailPreview
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:66
* @route '/invoices/email-preview/{reference}'
*/
emailPreviewForm.head = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: emailPreview.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

emailPreview.form = emailPreviewForm

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::email
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:114
* @route '/invoices/email/{reference}'
*/
export const email = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: email.url(args, options),
    method: 'post',
})

email.definition = {
    methods: ["post"],
    url: '/invoices/email/{reference}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::email
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:114
* @route '/invoices/email/{reference}'
*/
email.url = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { reference: args }
    }

    if (Array.isArray(args)) {
        args = {
            reference: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        reference: args.reference,
    }

    return email.definition.url
            .replace('{reference}', parsedArgs.reference.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::email
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:114
* @route '/invoices/email/{reference}'
*/
email.post = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: email.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::email
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:114
* @route '/invoices/email/{reference}'
*/
const emailForm = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: email.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::email
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:114
* @route '/invoices/email/{reference}'
*/
emailForm.post = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: email.url(args, options),
    method: 'post',
})

email.form = emailForm

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::extensionsPdf
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:252
* @route '/invoices/extensions-pdf/{reference}'
*/
export const extensionsPdf = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: extensionsPdf.url(args, options),
    method: 'get',
})

extensionsPdf.definition = {
    methods: ["get","head"],
    url: '/invoices/extensions-pdf/{reference}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::extensionsPdf
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:252
* @route '/invoices/extensions-pdf/{reference}'
*/
extensionsPdf.url = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { reference: args }
    }

    if (Array.isArray(args)) {
        args = {
            reference: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        reference: args.reference,
    }

    return extensionsPdf.definition.url
            .replace('{reference}', parsedArgs.reference.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::extensionsPdf
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:252
* @route '/invoices/extensions-pdf/{reference}'
*/
extensionsPdf.get = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: extensionsPdf.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::extensionsPdf
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:252
* @route '/invoices/extensions-pdf/{reference}'
*/
extensionsPdf.head = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: extensionsPdf.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::extensionsPdf
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:252
* @route '/invoices/extensions-pdf/{reference}'
*/
const extensionsPdfForm = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: extensionsPdf.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::extensionsPdf
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:252
* @route '/invoices/extensions-pdf/{reference}'
*/
extensionsPdfForm.get = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: extensionsPdf.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Invoices\InvoiceController::extensionsPdf
* @see app/Http/Controllers/Admin/Invoices/InvoiceController.php:252
* @route '/invoices/extensions-pdf/{reference}'
*/
extensionsPdfForm.head = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: extensionsPdf.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

extensionsPdf.form = extensionsPdfForm

const invoices = {
    pdf: Object.assign(pdf, pdf),
    emailPreview: Object.assign(emailPreview, emailPreview),
    email: Object.assign(email, email),
    extensionsPdf: Object.assign(extensionsPdf, extensionsPdf),
}

export default invoices